const IconInfo = () => (
  <div className="swal2-icon swal2-info swal2-icon-show d-flex">
    <div className="swal2-icon-content">i</div>
  </div>
);

export default IconInfo;
